module.exports = __webpack_public_path__ + "img/2.33bae28.png";